import TyCellWithImg from './TyCellWithImg.vue'
export default TyCellWithImg



// WEBPACK FOOTER //
// ./src/components/ty-cell-with-img/index.js